import { startTransition, useCallback } from "react";
const callImmediate = cb => cb();
function createShallowSetState(setter, onlyAllow, transition, debugIn) {
  return useCallback(next => {
    (transition ? startTransition : callImmediate)(() => {
      setter(prev => mergeIfNotShallowEqual(prev, next, onlyAllow, debugIn));
    });
  }, [setter, onlyAllow ? onlyAllow.join("") : "", transition, debugIn]);
}
function mergeIfNotShallowEqual(prev, next, onlyAllow, debug) {
  if (onlyAllow) {
    let allowed = {};
    for (const key in next) onlyAllow.includes(key) && (allowed[key] = next[key]);
    next = allowed;
  }
  if (!prev || !next || isEqualShallow(prev, next)) return prev || next;
  if (process.env.NODE_ENV === "development" && debug && (console.info("setStateShallow CHANGE", {
    prev,
    next
  }), debug === "break")) debugger;
  return {
    ...prev,
    ...next
  };
}
function isEqualShallow(prev, next) {
  for (const key in next) if (prev[key] !== next[key]) return !1;
  return !0;
}
export { createShallowSetState, isEqualShallow, mergeIfNotShallowEqual };
//# sourceMappingURL=createShallowSetState.mjs.map
